import codePlugin from './codePlugin'
export { toggleCodeBlockType, isCodeBlock, insertNewLine } from './codePluginHelpers'

export default codePlugin
